import { Controller } from "@hotwired/stimulus"
import {
  SignInWithApple,
} from '@capacitor-community/apple-sign-in';

// Connects to data-controller="apple"
export default class extends Controller {
  connect() {
  }

  signIn() {
    let options = {
      clientId: 'com.appsbq.monich',
      redirectURI: '/',
      scopes: 'email',
      state: 'initial',
      nonce: 'nonce',
    };

    SignInWithApple.authorize(options)
      .then((result) => {
        fetch('/sign_in', {
          method: "POST",
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(result['response']),
        }).then(function(response) { return response.json(); })
          .then(response => {
          if (response['success'] === true) {
            // Turbo.visit('/onboarding', { action: 'replace' });
            window.location.href = '/onboarding';
          }
        })
         // Handle user information
        // Validate token with server and create new session
      })
      .catch(error => {
        // Handle error
      });
  }
}
